import { Icon } from '@iconify/react';
import React from 'react';

const AgentsFilesIcon: React.FC<{ active: boolean }> = ({ active }) => {
  if (active) {
    return (
      <Icon
        icon="basil:invoice-solid"
        height={51}
        width={55}
        color={'#C1FE40'}
        style={{ transform: 'scale(1, -1)' }}
      />
    );
  } else {
    return (
      <Icon
        icon="basil:invoice-solid"
        height={51}
        width={55}
        color={'#2A3447'}
        style={{ transform: 'scale(1, -1)' }}
      />
    );
  }
};

export default AgentsFilesIcon;
